import React from 'react';
import { PageShell } from '../components/PageShell';
import { PortraitFrame } from '../components/PortraitFrame';
import { SectionHeading } from '../components/SectionHeading';
import { about } from '../data/profile';
export function About() {
  return <PageShell path="/about" data-id="element-146" data-mp="29hive6y3it0m">
      <section id="biography" className="bg-white py-20 lg:py-24" aria-labelledby="biography-heading" data-id="element-147" data-mp="2eigm57x68vdq">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-148" data-mp="328kh6qwanmt4">
          <div className="lg:col-span-7" data-id="element-149" data-mp="377nlua8d3r0k">
            <div id="biography-heading" data-id="element-150" data-mp="375b5u2m5zqq5">
              <SectionHeading eyebrow="Biography" title="A governance executive, plainly described" data-id="element-151" data-mp="2samqzxuvjfxv" />
            </div>
            <div className="mt-8 space-y-6" data-id="element-152" data-mp="2x86hbw4ujj66">
              {about.biography.map(paragraph => <p key={paragraph.slice(0, 32)} className="font-sans text-base leading-relaxed text-charcoal-700 lg:text-lg" data-id="element-153" data-mp="1gtwqmvd4tic6">
                  {paragraph}
                </p>)}
            </div>
          </div>

          <div className="lg:col-span-5" data-id="element-154" data-mp="1pj8h2xatf7gv">
            <div className="bg-navy-900 p-8 lg:p-10" data-id="element-155" data-mp="1pk9uh8fb061r">
              <PortraitFrame size="sm" data-id="element-156" data-mp="23izqsluau1p2" />
            </div>
            <dl className="mt-8 divide-y divide-platinum-200 border-y border-platinum-200" data-id="element-157" data-mp="23gdiul3hxk6b">
              {about.glance.map(item => <div key={item.label} className="flex items-baseline justify-between gap-6 py-4" data-id="element-158" data-mp="2dg4eiq3sm57z">
                  <dt className="font-sans text-sm text-charcoal-600" data-id="element-159" data-mp="28i2w87e6y9xk">{item.label}</dt>
                  <dd className="text-right font-display text-sm font-bold text-navy-900" data-id="element-160" data-mp="2m8pw42vou5v8">
                    {item.value}
                  </dd>
                </div>)}
            </dl>
          </div>
        </div>
      </section>

      <section id="philosophy" className="bg-platinum-100 py-20 lg:py-24" aria-labelledby="philosophy-heading" data-id="element-161" data-mp="2w7xamte5s6jx">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-162" data-mp="2r9lw45cx57vd">
          <div id="philosophy-heading" data-id="element-163" data-mp="1ovfrsiehrnxx">
            <SectionHeading eyebrow="Leadership Philosophy" title="Three convictions that shape how she leads" data-id="element-164" data-mp="1owhan91r1eq7" />
          </div>
          <ul className="mt-12 grid grid-cols-1 gap-px border border-platinum-200 bg-platinum-200 lg:grid-cols-3" data-id="element-165" data-mp="1xu9sajuy0ygr">
            {about.philosophy.map((item, index) => <li key={item.title} className="flex flex-col bg-white p-8 lg:p-10" data-id="element-166" data-mp="27le5be12698y" data-mpi={index}>
                <span className="font-display text-sm font-bold tracking-[0.12em] text-gold-600" data-id="element-167" data-mp="2ck79ugydapwz">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-4 font-display text-lg font-bold leading-snug tracking-tight text-navy-900" data-id="element-168" data-mp="2gjpwbh5u791x">
                  {item.title}
                </h3>
                <p className="mt-auto pt-4 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-169" data-mp="m8umycmtvpy3">
                  {item.text}
                </p>
              </li>)}
          </ul>
        </div>
      </section>
    </PageShell>;
}